export default {
    seguromovil: "",
    seguropatinete: "",
    seguromultidispositivo: "",
    seguroportatil: "",
    extensiondegarantia: "",
    insurama: ""
}